var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%", "min-height": "260px" } }, [
    _c(
      "form",
      {
        staticStyle: { width: "100%", "margin-top": "30px" },
        attrs: { "data-vv-scope": "perfilEmpresa" }
      },
      [
        _c(
          "vs-row",
          [
            _c(
              "vs-col",
              {
                attrs: {
                  "vs-type": "flex",
                  "vs-justify": "left",
                  "vs-align": "left",
                  "vs-w": "12"
                }
              },
              [_vm._v("Tipo de Compra")]
            )
          ],
          1
        ),
        _c(
          "vs-row",
          [
            _c(
              "vs-col",
              {
                attrs: {
                  "vs-type": "flex",
                  "vs-justify": "center",
                  "vs-align": "center",
                  "vs-w": "12"
                }
              },
              [
                _c("vs-select", {
                  staticStyle: { width: "100%" },
                  attrs: { options: _vm.codigos },
                  model: {
                    value: _vm.selectedCompra,
                    callback: function($$v) {
                      _vm.selectedCompra = $$v
                    },
                    expression: "selectedCompra"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "vs-row",
          [
            _c(
              "vs-col",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  "vs-type": "flex",
                  "vs-justify": "left",
                  "vs-align": "left",
                  "vs-w": "12"
                }
              },
              [_vm._v("Código IVA e impuestos")]
            )
          ],
          1
        ),
        _c(
          "vs-row",
          [
            _c(
              "vs-col",
              {
                attrs: {
                  "vs-type": "flex",
                  "vs-justify": "center",
                  "vs-align": "center",
                  "vs-w": "12"
                }
              },
              [
                _c("vs-select", {
                  staticStyle: { width: "100%" },
                  attrs: { options: _vm.codigoIVA, required: "" },
                  model: {
                    value: _vm.selectedCodigoIVA,
                    callback: function($$v) {
                      _vm.selectedCodigoIVA = $$v
                    },
                    expression: "selectedCodigoIVA"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("div", [
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "50px" } },
            [
              _c(
                "vs-button",
                {
                  attrs: { color: "primary", type: "filled" },
                  on: {
                    click: function($event) {
                      return _vm.modificarTipoCompra()
                    }
                  }
                },
                [_vm._v("Modificar")]
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }